module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bfsp-box"
  }, [_c('video', {
    attrs: {
      "src": _vm.url,
      "controls": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95adaa70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/bofangshipin/bofangshipin.vue
// module id = 997
// module chunks = 1